import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import PrivateRouteElement from "../PrivateRouteElement/PrivateRouteElement";
import { Navigate } from "react-router-dom";
import { PATHS } from "../paths";

const AdminRouteElement = ({ children }) => {
    const { keycloak } = useKeycloak();

    const isAdmin = keycloak.hasRealmRole("admin");

    if (!isAdmin) {
        return <Navigate to={PATHS.root} replace />;
    }

    return <PrivateRouteElement>{children}</PrivateRouteElement>;
};

export default AdminRouteElement;